<template>
  <v-dialog value="true" class="d-flex" persistent width="1200px">
    <edit-winner-dialog
      v-if="isEditingWinner"
      :newWinner="newWinner"
      :previousWinner="previousWinner"
      :setNewWinner="setNewWinner"
      @close="closeEditWinnerDialog"
      @save="saveWinner"
    />
    <v-card class="dialog-content pa-8 d-flex flex-column" height="650px">
      <h3 class="title mb-6">Registrar sorteado</h3>
      <p class="mb-0">
        Prêmio: {{ prize.title }} <br />
        Quantidade : {{ prize.quantity }}
      </p>
      <v-row class="ma-0 flex-row justify-space-between align-center">
        <h4 class="ma-0">Vencedores registrados</h4>
        <v-container class="ma-0" style="width: 300px">
          <mf-search v-model="prizeSearch" hide-details label="Busca" />
        </v-container>
      </v-row>
      <winners-table :winners="displayedWinners" :emptyTableMessage="emptyTableMessage" @editWinner="editWinner" @prizeStatusChange="checkForChanges" />
      <div class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <mf-button class="mr-3" :disabled="remainingWinners <= 0" label="Inserir ganhador" @click="insertWinner" />
          <p class="d-flex align-center">Prêmios a serem registrados: {{ remainingWinners }}</p>
        </div>
        <mf-action-buttons
          :primary-button="{
            text: 'Salvar',
            action: formatAndSavePrize,
            isVisible: true,
            isDisabled: !winnerListHasChanged,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: () => $emit('close'),
            isVisible: true,
          }"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

import { deepDelete } from '@/helpers/deepDelete'
import EditWinnerDialog from './EditWinnerDialog.vue'
import WinnersTable from './WinnersTable.vue'
import { diacriticSpaceSensitiveRegex } from '@/helpers/search.js'

export default {
  name: 'RegisterWinnerDialog',
  components: {
    EditWinnerDialog,
    WinnersTable,
  },
  props: {
    prize: {
      type: Object,
      required: true,
    },
    savePrize: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    isEditingWinner: false,
    previousWinner: null,
    newWinner: null,
    winnerListHasChanged: false,
    prizeSearch: '',
    displayedWinners: [],
    winners: [],
    emptyTableMessage: 'Nenhum sorteado foi registrado ainda.',
  }),
  computed: {
    remainingWinners() {
      return this.prize.quantity - this.winners.length
    },
  },
  watch: {
    prizeSearch() {
      this.setDisplayedWinners()
    },
    winners() {
      this.checkForChanges()
      this.setDisplayedWinners()
    },
  },
  mounted() {
    this.winners = cloneDeep(this.prize.winners)
  },
  methods: {
    insertWinner() {
      this.isEditingWinner = true
    },
    closeEditWinnerDialog() {
      this.isEditingWinner = false
      this.previousWinner = null
      this.newWinner = null
    },
    editWinner(index, props) {
      const itemIndex = (props.page - 1) * 5 + index
      this.previousWinner = {
        ...this.winners[itemIndex],
        index: itemIndex,
      }
      this.isEditingWinner = true
    },
    setNewWinner(newWinner) {
      this.newWinner = newWinner
    },
    saveWinner() {
      if (this.previousWinner) {
        this.winners.splice(this.previousWinner.index, 1, this.newWinner)
      } else {
        this.winners.push(this.newWinner)
      }
      this.isEditingWinner = false
      this.previousWinner = null
      this.newWinner = null
    },
    checkForChanges() {
      if (JSON.stringify(this.winners) !== JSON.stringify(this.prize.winners)) {
        this.winnerListHasChanged = true
      } else {
        this.winnerListHasChanged = false
      }
    },
    formatAndSavePrize() {
      const formattedWinners = this.winners.map((winner) => {
        let notifications = winner.notifications
        deepDelete(notifications, ['__typename'])

        return {
          _id: winner._id,
          document_no: winner.user.document_no,
          user_id_erp: winner.user.id_erp,
          lucky_number: {
            unit_id_erp: winner.lucky_number.unit.id_erp,
            coupon_id: winner.lucky_number.coupon_id,
            number: winner.lucky_number.number,
            created_at: winner.lucky_number.created_at,
          },
          prize_given: winner.prize_given,
          notifications,
        }
      })

      this.savePrize(formattedWinners, this.prize._id)
    },
    filterItemsBySearch(search) {
      const searchRegex = diacriticSpaceSensitiveRegex(search)
      const filteredItems = this.winners.filter(
        (item) => item.lucky_number.number.toString().match(searchRegex) || item.lucky_number.unit.name.match(searchRegex) || item.user.name.match(searchRegex)
      )
      this.displayedWinners = filteredItems
    },
    setDisplayedWinners() {
      if (!this.prizeSearch) {
        this.displayedWinners = this.winners
        this.emptyTableMessage = 'Nenhum sorteado foi registrado ainda.'
      } else {
        this.emptyTableMessage = 'Não foi encontrado nenhum resultado do termo pesquisado.'
        this.filterItemsBySearch(this.prizeSearch)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  margin-bottom: 0;
}
h4 {
  font-weight: 800;
}
.dialog-content {
  .block-title {
    opacity: 0.8;
    font-size: 18px;
    font-weight: bold;
    color: $preto;
  }
}
</style>
